import { ApiBase } from './ApiBase';
class GiftCardsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getGiftCards = (params) => {
            return this.get(`/gift-cards`, params);
        };
        this.getGiftCard = (params) => {
            return this.get(`/gift-cards/${params.id}`);
        };
        this.getGiftCardGroup = (params) => {
            return this.get(`/gift-cards/groups/${params.groupId}`);
        };
        this.createGiftCard = (payload) => {
            return this.post(`/gift-cards`, payload);
        };
        this.createGiftCardGroup = (payload) => {
            return this.post(`/gift-cards/groups`, payload);
        };
        this.updateGiftCard = (params, payload) => {
            return this.put(`/gift-cards/${params.id}`, payload);
        };
        this.updateGiftCardGroup = (params, payload) => {
            return this.put(`/gift-cards/groups/${params.groupId}`, payload);
        };
    }
}
export const GiftCardsApiClient = new GiftCardsApiClientModel();
